<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
             <a-col :span="12">
               <a-form-model-item :label="$t('勘察相约时间')" prop="investigationMeetTime">
                 <a-date-picker show-time :placeholder="$t('请选择勘察相约时间')" valueFormat="YYYY-MM-DD HH:mm:sss" v-model="model.investigationMeetTime"  style="width: 100%" />
               </a-form-model-item>
             </a-col>
             <a-col :span="12">
               <a-form-model-item :label="$t('勘察实际时间')" prop="investigationActualTime">
                 <a-date-picker show-time :placeholder="$t('请选择勘察实际时间')" valueFormat="YYYY-MM-DD HH:mm:sss" v-model="model.investigationActualTime"  style="width: 100%" />
               </a-form-model-item>
             </a-col>
            </a-row>
            <a-row :gutter="24">
             <a-col :span="12">
               <a-form-model-item :label="$t('安全状况')" prop="securityPosture">
                 <a-select v-model="model.securityPosture" :placeholder="$t('请选择安全状况')">
                   <a-select-option value="0">{{ $t('正常') }}</a-select-option>
                   <a-select-option value="1">{{ $t('恶劣') }}</a-select-option>
                   <a-select-option value="2">{{ $t('极度恶劣') }}</a-select-option>
                 </a-select>
               </a-form-model-item>
             </a-col>
             <a-col :span="12">
               <a-form-model-item :label="$t('施工环境')" prop="constructionEnvironment">
                 <a-input v-model="model.constructionEnvironment" :placeholder="$t('请输入施工环境')"  ></a-input>
               </a-form-model-item>
             </a-col>
            </a-row>
            <a-row :gutter="24">
             <a-col :span="12">
               <a-form-model-item :label="$t('日供水量(m³)')" prop="dailyWaterSupply">
                 <a-input-number v-model="model.dailyWaterSupply" :placeholder="$t('请输入日供水量')" style="width: 100%" />
               </a-form-model-item>
             </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="24">
                <a-form-model-item :label="$t('附件')" prop="annex">
                  <!-- <a-upload name="file" :multiple="false" :fileList="fileList">
                      <a-button>
                          <a-icon type="upload" />
                          选择附件
                      </a-button>
                  </a-upload> -->
                  <JUpload v-model="fileList" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
             <a-col :span="24">
               <a-form-model-item :label="$t('图片')" prop="picture">
                 <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="picture" :disabled="true"></j-image-upload>
               </a-form-model-item>
             </a-col>
            </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </a-modal>
</template>

<script>
  import { httpAction, getAction,postAction } from '@/api/manage'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import JUpload from '@/components/jeecg/JUpload'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  export default{
    components:{
      JImageUpload,
      JUpload
    },
    data() {
      return {
        title: '',
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {},
        url: {},
        fileList:[],
        picture:''
      }
    },
    computed: {
      formDisabled() {
        return this.disableSubmit
      },
    },
    created() {},
    methods:{
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        this.$nextTick(()=>{
          this.$set(this,'picture',this.model.picture);
        })
        if (this.model.annex == null) {
          this.fileList = []
        } else {
          // this.fileList = [
          //   {
          //     uid: '1',
          //     name: this.model.annexName,
          //     status: 'done ',
          //     linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
          //     url: historyFileUrl + '/' + this.model.annex,
          //   },
          // ]
          this.fileList = [this.model.annex];
        }
        if(type == 'detail'){
          this.disableSubmit = true;
          this.title = this.$t('详情');
        }else{
          this.disableSubmit = false;
          if(this.model.id){
            this.title = this.$t('编辑');
          }else{
            this.title = this.$t('新增');
          }
        }
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      handleOk(){
        
      }
    }
  }
</script>

<style scoped>
  .avatar-uploader>.ant-upload {
    width: 104px;
    height: 104px;
  }
</style>